export default {
  signing: false,
};
